import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/jilu-a.png'
import _imports_1 from '@/assets/img/jilu.png'
import _imports_2 from '@/assets/img/grsucai-a.png'
import _imports_3 from '@/assets/img/grsucai.png'
import _imports_4 from '@/assets/img/xiazai.png'
import _imports_5 from '@/assets/img/kefu.png'


const _hoisted_1 = { class: "aside-container" }
const _hoisted_2 = { class: "aside-menu" }
const _hoisted_3 = { class: "aside-menu-box" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "aside-menu-box-inner" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "aside-footer" }
const _hoisted_8 = { class: "aside-footer-box" }
const _hoisted_9 = { class: "aside-footer-box-inner" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0
}
const _hoisted_11 = {
  key: 1,
  src: _imports_1
}
const _hoisted_12 = { class: "aside-footer-box-inner" }
const _hoisted_13 = {
  key: 0,
  src: _imports_2
}
const _hoisted_14 = {
  key: 1,
  src: _imports_3
}
const _hoisted_15 = { class: "aside-footer-scan" }
const _hoisted_16 = { class: "aside-footer-scan-img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "aside-footer-scan-img" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "popup-inner online-inner" }
const _hoisted_21 = { class: "online-popup" }
const _hoisted_22 = { class: "online-qrcode" }
const _hoisted_23 = ["src"]

import { ref, onMounted, watch } from 'vue';
import { useStore } from "vuex"
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus'
import { getConfigByCode, getConfigByCodeV1 } from "@/api/common.js"

export default /*@__PURE__*/_defineComponent({
  __name: 'layoutAside',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const userInfo = ref(store.state.userInfo)
const configObj = ref({
    customer_code: '',
    ANDROID_DOWN_URL: '',
    IOS_DOWN_URL: '',
    customerPhone: ''
})
const menuList = [
    {
        label: '作文秒评',
        path: '/composition/correct',
        name: 'correct',
        icon: require("@/assets/img/pingyue.png"),
        activeIcon: require("@/assets/img/pingyue-a.png")
    },
    {
        label: 'AI+开悟作文',
        path: '/composition/teaching',
        name: 'teaching',
        icon: require("@/assets/img/jiaoxue.png"),
        activeIcon: require("@/assets/img/jiaoxue-a.png")
    },
    {
        label: '开悟微课',
        icon: require("@/assets/img/weike.png"),
        activeIcon: require("@/assets/img/weike-a.png")
    },
    {
        label: 'AI润色',
        path: '/composition/polish',
        name: 'polish',
        icon: require("@/assets/img/runse.png"),
        activeIcon: require("@/assets/img/runse-a.png")
    },
    {
        label: '三步九法AI点拨',
        path: '/composition/guide',
        name: 'guide',
        icon: require("@/assets/img/zhidao.png"),
        activeIcon: require("@/assets/img/zhidao-a.png")
    },
    {
        label: '中/高考指导',
        icon: require("@/assets/img/kaoshi.png"),
        activeIcon: require("@/assets/img/kaoshi-a.png")
    },
    {
        label: 'AI范文',
        path: '/composition/modelEssay',
        name: 'modelEssay',
        icon: require("@/assets/img/fanwen.png"),
        activeIcon: require("@/assets/img/fanwen-a.png")
    },
    // {
    //     label: '作文重写',
    //     icon: require("@/assets/img/chongxie.png"),
    //     activeIcon: require("@/assets/img/chongxie-a.png")
    // },
    {
        label: '作文真题',
        path: '/composition/pastExamPaper',
        name: 'pastExamPaper',
        icon: require("@/assets/img/zhenti.png"),
        activeIcon: require("@/assets/img/zhenti-a.png")
    },
    {
        label: '写作素材',
        path: '/composition/sourceMaterial',
        name: 'sourceMaterial',
        icon: require("@/assets/img/sucai.png"),
        activeIcon: require("@/assets/img/sucai-a.png")
    },
    // {
    //     label: 'AI作文',
    //     icon: require("@/assets/img/zuowen.png"),
    //     activeIcon: require("@/assets/img/zuowen-a.png")
    // }
]
const activeName = ref('correct')
const popupShow = ref(false)
watch(() => route.path, () => {
    activeName.value = route.name;

}, {
        immediate: true
    });
function menuClick(item: { label: string, name: string, path: string }) {
    if (item.name != activeName.value) {
        if (!userInfo.value.userId) {
            if (!['/composition/teaching', '/composition/pastExamPaper'].includes(item.path)) {
                return store.dispatch('setLoginFlag')
            } else {
                router.push(item.path)
            }
        }
        if (item.label == '作文重写') {
            router.push('/composition/workHistory')
        }else if(!item.path){
            ElMessage.warning('功能暂未开放！');
        } else {
            router.push(item.path)
        }

    }
}
function getConfig(flag) {
    getConfigByCode(flag).then(res => {
        configObj.value[flag] = res.data;
    })
}

function getConfigV1(flag) {
    getConfigByCodeV1(flag).then(res => {
        configObj.value[flag] = res.data.fileUrl;
    })
}

function recordClick() {
    let obj = {
        label: '作文记录',
        path: '/composition/workHistory',
        name: 'workHistory'
    }
    menuClick(obj)
}
function sourceClick() {
    let obj = {
        label: '个人素材库',
        path: '/composition/sourceMaterialMy',
        name: 'sourceMaterialMy'
    }
    menuClick(obj)
}
onMounted(() => {
    getConfig('customerPhone')
    getConfigV1('customer_code')
    getConfigV1('ANDROID_DOWN_URL')
    getConfigV1('IOS_DOWN_URL')
})

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item, index) => {
          return _createElementVNode("li", {
            key: index,
            class: _normalizeClass(activeName.value==item.name?'active':''),
            onClick: ($event: any) => (menuClick(item,index))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: activeName.value==item.name?item.icon:item.activeIcon
              }, null, 8, _hoisted_6),
              _createElementVNode("span", null, _toDisplayString(item.label), 1)
            ])
          ], 10, _hoisted_4)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", {
          onClick: recordClick,
          class: _normalizeClass(activeName.value=='workHistory'?'active':'')
        }, [
          _createElementVNode("div", _hoisted_9, [
            (activeName.value=='workHistory')
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true),
            (activeName.value!='workHistory')
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : _createCommentVNode("", true),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "作文记录", -1))
          ])
        ], 2),
        _createElementVNode("li", {
          onClick: sourceClick,
          class: _normalizeClass(activeName.value=='sourceMaterialMy'?'active':'')
        }, [
          _createElementVNode("div", _hoisted_12, [
            (activeName.value=='sourceMaterialMy')
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : _createCommentVNode("", true),
            (activeName.value!='sourceMaterialMy')
              ? (_openBlock(), _createElementBlock("img", _hoisted_14))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "个人素材库", -1))
          ])
        ], 2),
        _createElementVNode("li", null, [
          _createVNode(_component_el_popover, {
            "popper-class": "aside-footer-popover",
            placement: "right",
            trigger: "click"
          }, {
            reference: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "aside-footer-box-inner" }, [
                _createElementVNode("img", { src: _imports_4 }),
                _createElementVNode("span", null, "APP下载")
              ], -1)
            ])),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: configObj.value.ANDROID_DOWN_URL
                    }, null, 8, _hoisted_17)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", null, "安卓版扫码下载", -1))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("img", {
                      src: configObj.value.IOS_DOWN_URL
                    }, null, 8, _hoisted_19)
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", null, "IOS版扫码下载", -1))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (popupShow.value=true))
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "aside-footer-box-inner" }, [
            _createElementVNode("img", { src: _imports_5 }),
            _createElementVNode("span", null, "联系客服")
          ], -1)
        ]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: popupShow.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupShow).value = $event)),
      title: "开悟作文在线客服",
      width: "300px",
      center: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "online-popup" }, " 工作时间：周一至周五 9:00-18:00 ", -1)),
          _createElementVNode("div", _hoisted_21, " 客服电话：" + _toDisplayString(configObj.value.customerPhone), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("img", {
              src: configObj.value.customer_code
            }, null, 8, _hoisted_23)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", null, "扫描二维码联系在线客服", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})